module.exports = __webpack_public_path__ + "img/logo_p.fbd3a86c.svg";